import React, { Component } from 'react';

class GoogleMap extends Component {
  constructor(props) {
    super(props);

    this.map = undefined;
    this.directionsService = undefined;
    this.directionsRenderer = undefined;
    this.placesService = undefined;

    this.state = {
      startLocation: '',
      endLocation: ''
    }

    this.onScriptLoad = this.onScriptLoad.bind(this);
  }

  updateMap(start, end, travelMode) {
    if (travelMode === 'DRIVING') {
      const directionsRequest = {
        origin: start,
        destination: end,
        travelMode: travelMode
      };

      this.directionsService.route(directionsRequest, (directions, status) => {
        switch (status) {
          case 'OK':
            this.setState({
              startLocation: directions.routes[0].legs[0].start_location,
              endLocation: directions.routes[0].legs[0].end_location
            });

            this.directionsRenderer.setDirections(directions);
            
            const distance = directions.routes[0].legs[0].distance.value;
            this.props.calculateAllocations(distance);
            break;
          case 'NOT_FOUND':
            alert('The starting location or destination is invalid.');
            break;
          case 'ZERO_RESULTS':
            alert('Driving between these locations is unavailable.');
            break;
          default:
            alert('An unknown error occurred.');
            break;
        }
      });
    } else {
      // google's places api is strange since it is dependant on callbacks for requests
      this.handleFlying({
        start: start,
        end: end
      });
    }
  }

  handleFlying(locations) {
    this.getStartPlace(locations);
  }

  getStartPlace(locations) {
    const request = {
      query: locations.start,
      fields: ['geometry']
    };

    this.placesService.findPlaceFromQuery(request, (place, status) => {
      if (status === 'OK') {
        this.setState({ startLocation: place[0].geometry.location });
        this.getEndPlace(locations);
      }
    });
  }

  getEndPlace(locations) {
    const request = {
      query: locations.end,
      fields: ['geometry']
    };

    this.placesService.findPlaceFromQuery(request, (place, status) => {
      if (status === 'OK') {
        this.setState({ endLocation: place[0].geometry.location });
        this.cleanUpFlying();
      }
    });
  }

  cleanUpFlying() {
    console.log(window.google.maps);

    const route = new window.google.maps.Polyline({
      path: [
        this.state.startLocation,
        this.state.endLocation
      ],
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });

    route.setMap(this.map);

    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(this.state.startLocation, this.state.endLocation);
    this.props.calculateAllocations(distance);
  }

  onScriptLoad() {
    this.map = new window.google.maps.Map(
      document.getElementById('google-map'),
      this.props.options
    );
    this.props.onMapLoad();

    this.directionsService = new window.google.maps.DirectionsService();
    this.directionsRenderer = new window.google.maps.DirectionsRenderer()
    this.directionsRenderer.setMap(this.map)

    this.placesService = new window.google.maps.places.PlacesService(this.map);
  }

  componentDidMount() {
    if (!window.google) {
      const mapScript = document.createElement('script');
      mapScript.setAttribute('type', 'text/javascript');
      mapScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDLG8gkUKsj0tEnsIZ4zNhNUJ8BUVIIKag&libraries=places');

      var scripts = document.getElementsByTagName('script')[0];
      scripts.parentNode.insertBefore(mapScript, scripts);

      mapScript.addEventListener('load', e => {
        this.onScriptLoad();
      });
    } else {
      this.onScriptLoad();
    }
  }

  render() {
    return (
      <div id="google-map" style={{ width: '400px', height: '300px' }} />
    );
  }

}

export default GoogleMap;